import { mapGetters, mapMutations } from 'vuex'

import {CONSTANTS} from '@/config/constants';

import headerMenu from '@/components/header/header-menu/index.vue'
import headerSidebar from '@/components/header/header-sidebar/index.vue'

export default {
  name: 'Header',
  //---components
  components: {
    headerMenu,
    headerSidebar,
  },
  //--data
  data () {
    return {
      headerData: {
        siteUrl: process.env.VUE_APP_PTF_SITE_URL,
        logoSrc: require('@/assets/img/src/logo_fox@3x.png'),
        userAvatar: require('@/assets/img/src/icon-men.png'),
        links: [
          {
            title: 'Homeowners',
            url: process.env.VUE_APP_PTF_SITE_URL + '/homeowners'
          },
          {
            title: 'Professionals',
            url: process.env.VUE_APP_PTF_SITE_URL + '/professionals'
          },
          {
            title: 'Contact Us',
            url: process.env.VUE_APP_PTF_SITE_URL + '/contact-us'
          },
        ],
        menu: [
          {
            title: 'Dashboard',
            name: 'dashboard',
            isAuthRequired: true,
          },
          {
            title: 'Properties',
            name: 'properties'
          },
          {
            title: 'Notifications',
            name: 'notifications',
            isAuthRequired: true
          }
        ],
        btn: {
          title: 'File Appeal',
          url: process.env.VUE_APP_FILE_APPEAL_URL
        },
        breakpoint: CONSTANTS.APP_HEADER_BREAKPOINT
      }
    }
  },
  //---hooks
  computed: {
    ...mapGetters({
      isShowSidebar: 'APP/isHeaderSidebarShow',
      appSize: 'APP/appSize',
      user: 'AUTH/user',
    }),

    isMobileView() {
      return (this.appSize && this.appSize.width <= this.headerData.breakpoint);
    }
  },
  watch: {
    appSize() {
      if (!this.isMobileView) {
        this.setHeaderSidebarFlag(false);
      }
    }
  },
  //---methods
  methods: {
    ...mapMutations({
      setHeaderSidebarFlag: 'APP/APP_HEADER_SIDEBAR_SHOW_FLAG_TOGGLE'
    }),
    toggleHeaderSidebar() {
      this.isShowSidebar ? this.setHeaderSidebarFlag(false) : this.setHeaderSidebarFlag(true);
    }
  }
}